import { Box, Button, CircularProgress } from '@mui/material';
import { FC, useRef, useState } from 'react';
import PinInput from 'react-pin-input';
import { Alert } from '../../../shared/lib/common/Alert';
import { PageHeading } from '../../../shared/lib/common/PageHeading';
import { useAddSecurityPinMutation } from '../generated';
import { ONBOARDING_PIN_STRINGS } from '../../../shared/lib/constants';
import palette from '../../../shared/lib/theme/palette';
import { StepperContentWrapper } from '../../../shared/lib/theme/styleConstants';
import { useAppContext } from '../app/contexts/AppContext';
import { StepperStepsProps } from '../app/interfaceTypes';
import { CustomPinInput } from './CustomPinInput';
import { useMobileView } from '../app/hooks/useMobileView';

export const SetUpYourPinCode: FC<StepperStepsProps> = ({ handleNext }) => {
  const mediumViewport = useMobileView();
  const { currentUser, setCurrentUser } = useAppContext();
  const pinRef = useRef<PinInput | null>(null);
  const [tpin, setTpin] = useState<string>('');
  const { blackOne } = palette;

  const onChange = (value: string) => {
    setTpin(value);
  };

  const [addSecurityPin, { loading }] = useAddSecurityPinMutation({
    onError({ message }) {
      Alert.error(message);
      setTpin('');
      pinRef.current?.clear();
    },

    onCompleted() {
      if (currentUser) {
        const { status: userStatus, email, emailVerified, isSubscribed, phoneNumber: currentPhoneNumber } = currentUser;
        const isTPinAdded = true;
        const phoneNumber = currentPhoneNumber?.startsWith('+') ? currentPhoneNumber : `+${currentPhoneNumber}`;
        const updatedUser = { ...currentUser, status: userStatus, email, emailVerified, isSubscribed, isTPinAdded, phoneNumber };
        setCurrentUser(updatedUser);
        handleNext?.();
      }
    }
  });

  const onTpinSubmit = async () => {
    tpin &&
      (await addSecurityPin({
        variables: {
          addOrUpdateSecurityPinInput: {
            securityPin: tpin
          }
        }
      }));
  };

  return (
    <Box sx={StepperContentWrapper}>
      <Box width={mediumViewport ? '100%' : '500px'} margin="auto">
        <PageHeading color={blackOne} title={ONBOARDING_PIN_STRINGS.TITLE} subTitle={ONBOARDING_PIN_STRINGS.DESCRIPTION} />

        <CustomPinInput onChange={onChange} pinRef={pinRef} />

        <Button variant="contained" fullWidth onClick={onTpinSubmit} disabled={loading || tpin.length < 6} endIcon={loading && <CircularProgress size={20} color="inherit" />}>
          {ONBOARDING_PIN_STRINGS.BUTTON_NEXT}
        </Button>
      </Box>
    </Box>
  );
};
